export const initialState = {
    loading: false,
};
